import type { BooksApi } from '../apis';
import { CacheTTL } from '../constants';
import type { KeyCount } from '../models';

export class BooksRepository {
  constructor(private api: BooksApi) {}

  async getCount(): Promise<number> {
    const { data } = await this.api.getCount({
      cache: { ttl: CacheTTL.DEFAULT },
    });
    return data.count;
  }

  async getCountByPublisher(): Promise<KeyCount[]> {
    const { data } = await this.api.getCountsByPublisher({
      cache: { ttl: CacheTTL.DEFAULT },
    });
    return data.counts;
  }
}
